(function () {
  "use strict";

  const SLIDE_ID = "pwzrswiper-slide-spotlight";
  const INJECTED_ATTR = "data-spotlight-injected";
  const LOG = "[StyleSpotlight]";

  // ── 1. Read data element ──────────────────────────────────────────────────
  const dataEl = document.getElementById("StyleSpotlightData");
  if (!dataEl) {
    console.warn(
      LOG,
      "Data element #StyleSpotlightData not found – metafield may be empty or Liquid block missing",
    );
    return;
  }
  console.log(LOG, "Data element found, raw text:", dataEl.textContent.trim());

  let data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.error(LOG, "JSON parse failed:", e, "\nRaw:", dataEl.textContent);
    return;
  }
  console.log(LOG, "Parsed data:", data);

  if (!data.firstImageUrl) {
    console.warn(LOG, "firstImageUrl is missing from data");
    return;
  }

  // items may be an array directly, or wrapped in a Shopify metafield envelope
  let items = data.items;
  if (items && typeof items === "object" && !Array.isArray(items)) {
    items = items.value || items;
  }
  if (!Array.isArray(items) || items.length === 0) {
    console.warn(LOG, "items is empty or not an array:", items);
    return;
  }
  console.log(LOG, "Items count:", items.length, items);

  // ── 2. Inject CSS ─────────────────────────────────────────────────────────
  const style = document.createElement("style");
  style.textContent = `
    .style-spotlight-slide { position: relative; }
    .style-spotlight-inner {
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      overflow: hidden;
    }
    .style-spotlight-bg {
      width: 100%; height: 100%;
      object-fit: cover;
      position: absolute;
      inset: 0;
    }
    .style-spotlight-overlay {
      position: absolute;
      inset: 0;
      background: linear-gradient(to right, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0.15) 100%);
    }
    .style-spotlight-content {
      position: absolute;
      inset: 0;
      padding: 24px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .style-spotlight-heading {
      color: #fff;
      font-size: 20px;
      font-weight: 400;
      margin: 0 0 16px;
      letter-spacing: 0.02em;
    }
    .style-spotlight-row { margin: 6px 0; }
    .style-spotlight-row p { color: #fff; font-size: 14px; margin: 0; line-height: 1.5; }
    .style-spotlight-row strong { font-weight: 600; }
    .style-spotlight-row span { font-weight: 300; }
    .ss-anim {
      opacity: 0;
      transform: translateX(650px);
      transition: opacity 0.6s ease, transform 0.65s cubic-bezier(0.22, 1, 0.36, 1);
    }
    .ss-anim.ss-visible { opacity: 1; transform: translateX(0); }
    .style-spotlight-thumb-label {
      position: absolute;
      inset: 0;
      background: rgba(0,0,0,0.27);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 9px;
      text-align: center;
      line-height: 1.4;
      letter-spacing: 0.03em;
      pointer-events: none;
    }
    .pwzrjss5[role="button"] { cursor: pointer; }
    @media(max-width:768px){
      .style-spotlight-content{
        padding: 24px 24px 24px 70px;
      }
    }
  `;
  document.head.appendChild(style);

  // ── 3. Builders ───────────────────────────────────────────────────────────
  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function buildSlide(slideWidth) {
    const slide = document.createElement("div");
    slide.id = SLIDE_ID;
    slide.className = "pwzrswiper-slide style-spotlight-slide";
    // Non-numeric data-index so the Rio app's media-lookup (which does
    // parseInt on data-index) skips this slide and doesn't shift the
    // mapping between DOM slides and product media items.
    slide.setAttribute("data-index", "spotlight");
    slide.setAttribute("data-spotlight", "1");
    slide.style.cssText = `cursor:default;border-radius:0px;overflow:hidden;width:${slideWidth}px;padding-bottom:125%;position:relative;`;

    // On mobile the slide click opens the Rio lightbox, which would try to
    // open a numeric media index for this slide and either crash or show
    // the wrong image. On desktop the click is just "select this slide" —
    // we want that to work. Block only on touch-mode viewports.
    slide.addEventListener("click", function (e) {
      if (window.matchMedia("(max-width: 989px)").matches) {
        e.stopImmediatePropagation();
      }
    }, true);

    const imgUrl = data.firstImageUrl.startsWith("//")
      ? "https:" + data.firstImageUrl
      : data.firstImageUrl;

    const rows = items
      .map((item, i) => {
        const lbl = escapeHtml(item.label || "");
        const val = escapeHtml(item.content || "");
        return `<div class="style-spotlight-row ss-anim">
        <p><strong>${lbl}&nbsp;:&nbsp;</strong><span>${val}</span></p>
      </div>`;
      })
      .join("");

    slide.innerHTML = `
      <div class="style-spotlight-inner">
        <img class="style-spotlight-bg" src="${imgUrl}" alt="Style Spotlight">
        <div class="style-spotlight-overlay"></div>
        <div class="style-spotlight-content">
          <h2 class="style-spotlight-heading ss-anim">Style Spotlight</h2>
          ${rows}
        </div>
      </div>`;
    console.log(LOG, "buildSlide(): slide HTML built, imgUrl =", imgUrl);
    return slide;
  }

  function buildThumb() {
    const thumbUrl = data.firstImageUrl.replace(/width=\d+/, "width=360");
    const item = document.createElement("div");
    item.className =
      "PwzrGrid-root PwzrGrid-container PwzrGrid-item PwzrGrid-align-items-xs-center PwzrGrid-justify-xs-center";
    item.style.cssText =
      "min-width:114px;min-height:142.5px;width:114px;height:142.5px;";
    item.innerHTML = `
      <div role="button" tabindex="0" class="pwzrjss5" style="position:relative;width:106px;height:132.5px;border:1px solid transparent;border-radius:0px;overflow:hidden;cursor:pointer;">
        <img src="${thumbUrl}" class="pwzrjss3" style="width:100%;height:100%;object-fit:cover;">
        <div class="style-spotlight-thumb-label">Style<br>Spotlight</div>
      </div>`;
    return item;
  }

  // ── 4. Animation ──────────────────────────────────────────────────────────
  function resetAnims(slide) {
    slide.querySelectorAll(".ss-anim").forEach((el) => {
      // Kill the running transition instantly so the element snaps to hidden
      // state before we re-trigger. Without this the browser starts the
      // forward animation from whatever mid-transition value it had.
      el.style.transition = "none";
      el.classList.remove("ss-visible");
      void el.offsetHeight; // commit the style flush
      el.style.transition = ""; // restore CSS-defined transition
    });
  }

  let animTimers = [];

  function runAnimation(slide) {
    // Cancel any in-flight stagger timers before resetting
    animTimers.forEach(clearTimeout);
    animTimers = [];
    resetAnims(slide);
    // Two RAFs: first lets the browser register the restored CSS transition
    // rule after resetAnims clears the inline override; second starts the
    // staggered entry so each element fires from a clean hidden state.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const heading = slide.querySelector(".style-spotlight-heading");
        const rows = Array.from(slide.querySelectorAll(".style-spotlight-row"));
        if (heading) {
          animTimers.push(setTimeout(() => heading.classList.add("ss-visible"), 0));
        }
        rows.forEach((row, i) => {
          animTimers.push(setTimeout(() => row.classList.add("ss-visible"), 160 + i * 230));
        });
      });
    });
  }

  function watchActiveClass(slide) {
    // Check if the slide is already active at observer setup time (common on
    // mobile where the gallery marks slides synchronously before our observer
    // can fire).
    let wasActive = [...slide.classList].some((c) => c.includes("active"));
    if (wasActive) {
      console.log(LOG, "Slide already active at setup – triggering immediately");
      runAnimation(slide);
    }

    new MutationObserver(() => {
      // Match any gallery variant: pwzrswiper-slide-active, swiper-slide-active, etc.
      const isActive = [...slide.classList].some((c) => c.includes("active"));
      if (isActive && !wasActive) {
        console.log(LOG, "Spotlight became active – triggering animations");
        runAnimation(slide);
      }
      wasActive = isActive;
    }).observe(slide, { attributes: true, attributeFilter: ["class"] });

    // IntersectionObserver fallback: fires whenever the slide enters the
    // viewport, which catches mobile galleries that never set an active class.
    let iobPrev = false;
    new IntersectionObserver(
      (entries) => {
        const visible = entries[0].isIntersecting;
        if (visible && !iobPrev) {
          console.log(LOG, "Spotlight entered viewport (IOB) – triggering animations");
          runAnimation(slide);
        }
        iobPrev = visible;
      },
      { threshold: 0.4 },
    ).observe(slide);
  }

  // ── 5. Swiper instance helpers ─────────────────────────────────────────────
  function getSwiperInstance(wrapper) {
    if (!wrapper) return null;
    const container = wrapper.parentElement;
    if (container && container.swiper) return container.swiper;
    const swiperEl =
      document.querySelector(".pwzrswiper-container") ||
      wrapper.closest("[class*='swiper']");
    return swiperEl && swiperEl.swiper ? swiperEl.swiper : null;
  }

  // Tells Swiper to re-scan the DOM after we mutated it. Without this, its
  // cached slide list drifts out of sync — symptoms: swiping shows the wrong
  // image then snaps to the right one a beat later, nav arrows skip slides.
  function syncSwiper(wrapper) {
    const swiper = getSwiperInstance(wrapper);
    if (!swiper) {
      // Swiper hasn't mounted yet — retry a few times.
      let tries = 0;
      const retry = setInterval(() => {
        const s = getSwiperInstance(wrapper);
        if (s) {
          clearInterval(retry);
          try { s.update(); } catch (e) { console.warn(LOG, "swiper.update() failed", e); }
          console.log(LOG, "syncSwiper(): updated after retry", tries);
        } else if (++tries > 20) {
          clearInterval(retry);
          console.warn(LOG, "syncSwiper(): swiper instance never appeared");
        }
      }, 150);
      return;
    }
    try {
      swiper.update();
      console.log(LOG, "syncSwiper(): swiper.update() called");
    } catch (e) {
      console.warn(LOG, "swiper.update() failed", e);
    }
  }

  // Pwzrswiper doesn't expose its instance at container.swiper (we tried,
  // it's null). But pagination bullets are DOM-order-indexed and their
  // built-in click handler navigates correctly to the matching slide. We
  // use bullet clicks as our universal "go to slide N" primitive — works
  // for both nav arrows and lightbox-close restore.
  function findPagination(wrapper) {
    // pagination is a sibling of the container, inside the same .pwzrjss1
    const container = wrapper.closest(".pwzrswiper-container");
    if (!container) return null;
    // Walk up to .pwzrjss1 root and search for pagination
    const root = container.closest(".pwzrjss1") || container.parentElement?.parentElement;
    return root ? root.querySelector(".pwzrswiper-pagination") : null;
  }

  function getActiveDomIndex(wrapper) {
    const slides = Array.from(
      wrapper.querySelectorAll(":scope > .pwzrswiper-slide"),
    );
    const activeIdx = slides.findIndex((s) =>
      s.classList.contains("pwzrswiper-slide-active"),
    );
    return { slides, activeIdx };
  }

  function navigateToDomIndex(wrapper, targetIdx) {
    const slides = Array.from(
      wrapper.querySelectorAll(":scope > .pwzrswiper-slide"),
    );
    if (targetIdx < 0 || targetIdx >= slides.length) {
      console.warn(LOG, "navigateToDomIndex: target out of range", targetIdx, "/", slides.length);
      return false;
    }
    // Mobile: pagination bullets exist — click the matching bullet and let
    // the app's own handler do the navigation (it understands transitions,
    // updates state, etc).
    const pagination = findPagination(wrapper);
    if (pagination) {
      const bullets = pagination.querySelectorAll(".pwzrswiper-pagination-bullet");
      if (bullets[targetIdx]) {
        bullets[targetIdx].click();
        return true;
      }
    }
    // Desktop: no pagination — manipulate the swiper transform directly
    // and update the active/prev/next classes Swiper uses for styling.
    const targetLeft = slides[targetIdx].offsetLeft;
    wrapper.style.transitionDuration = "300ms";
    wrapper.style.transform = `translate3d(-${targetLeft}px, 0px, 0px)`;
    slides.forEach((s, i) => {
      s.classList.remove(
        "pwzrswiper-slide-active",
        "pwzrswiper-slide-prev",
        "pwzrswiper-slide-next",
      );
      if (i === targetIdx) s.classList.add("pwzrswiper-slide-active");
      if (i === targetIdx - 1) s.classList.add("pwzrswiper-slide-prev");
      if (i === targetIdx + 1) s.classList.add("pwzrswiper-slide-next");
    });
    return true;
  }

  // Desktop: thumbnails on the side. The Rio app's click handler maps
  // thumb → media-index by skipping our spotlight (it doesn't recognize
  // it), then calls swiper.slideTo(mediaIndex) which DOES count the
  // spotlight — landing one slot too early. We intercept in capture phase
  // and navigate the main to the same DOM position as the clicked thumb.
  function patchThumbs(wrapper) {
    const gallery = wrapper.closest(".rio-media-gallery");
    if (!gallery) return false;
    // Find the thumb grid: the .PwzrGrid-container that has multiple
    // direct .PwzrGrid-item children (the spotlight injector sets
    // data-spotlight-injected="1" on it already).
    const candidates = Array.from(
      gallery.querySelectorAll(".PwzrGrid-container"),
    );
    let thumbGrid = null;
    for (const g of candidates) {
      if (g.querySelectorAll(":scope > .PwzrGrid-item").length >= 2) {
        thumbGrid = g;
        break;
      }
    }
    if (!thumbGrid) return false;
    if (thumbGrid.hasAttribute("data-spotlight-thumbs-patched")) return true;
    thumbGrid.setAttribute("data-spotlight-thumbs-patched", "1");

    thumbGrid.addEventListener(
      "click",
      function (e) {
        const thumb = e.target.closest(".PwzrGrid-item");
        if (!thumb || !thumbGrid.contains(thumb)) return;
        const items = Array.from(
          thumbGrid.querySelectorAll(":scope > .PwzrGrid-item"),
        );
        const idx = items.indexOf(thumb);
        if (idx < 0) return;
        e.stopImmediatePropagation();
        e.preventDefault();
        console.log(LOG, "thumb click → DOM index", idx);
        navigateToDomIndex(wrapper, idx);
        // Update thumb visual selection (Rio uses a black border on the
        // inner .pwzrjss5 of the active thumb).
        items.forEach((t, i) => {
          const inner = t.querySelector(".pwzrjss5");
          if (!inner) return;
          inner.style.border =
            i === idx ? "1px solid rgb(0, 0, 0)" : "1px solid transparent";
        });
      },
      true,
    );
    console.log(LOG, "patchThumbs(): delegation installed on thumb grid");
    return true;
  }

  function watchForThumbPatch(wrapper) {
    if (patchThumbs(wrapper)) return;
    let tries = 0;
    const iv = setInterval(() => {
      if (patchThumbs(wrapper) || ++tries > 40) clearInterval(iv);
    }, 250);
  }

  // Override the gallery's nav arrows. The Rio app's own arrow handler
  // skips slides whose media-index doesn't exist (the video, our spotlight),
  // so it can wrap from the last image back to slide 0. We delegate the
  // override to the document in capture phase so it survives the app
  // re-rendering its buttons (which strips per-element listeners), and we
  // intercept pointerdown/touchend in addition to click since the app may
  // bind navigation to a pre-click event on touch devices.
  let arrowsBound = false;
  function patchArrows(wrapper) {
    if (arrowsBound) return true;
    arrowsBound = true;

    const advance = (dir) => {
      const { slides, activeIdx } = getActiveDomIndex(wrapper);
      if (activeIdx < 0) return;
      let target = dir === "next" ? activeIdx + 1 : activeIdx - 1;
      if (target >= slides.length) target = 0;
      if (target < 0) target = slides.length - 1;
      console.log(LOG, "arrow", dir, ":", activeIdx, "→", target, "/", slides.length);
      navigateToDomIndex(wrapper, target);
    };

    const handler = (e) => {
      const next = e.target.closest && e.target.closest(".pwzrswiper-btn-next");
      const prev = !next && e.target.closest && e.target.closest(".pwzrswiper-btn-prev");
      if (!next && !prev) return;
      // Only one event-type should fire the actual nav. We use pointerup if
      // available, falling back to click. For other event types we just
      // suppress so the app's handler doesn't run.
      e.stopImmediatePropagation();
      if (e.type === "pointerup" || (e.type === "click" && !("onpointerup" in window))) {
        advance(next ? "next" : "prev");
      } else if (e.type === "click") {
        // pointerup already handled this — suppress the synthesized click.
      }
    };

    ["pointerdown", "pointerup", "click", "touchstart", "touchend"].forEach(
      (evt) => {
        document.addEventListener(evt, handler, true);
      },
    );
    console.log(LOG, "patchArrows(): document-level delegation installed");
    return true;
  }

  function watchForArrows(wrapper) {
    patchArrows(wrapper);
  }

  // Lightbox-close drift: the Rio app's lightbox stores its own media-index
  // when it opens and tells the swiper to navigate there when it closes,
  // but its media-index is off-by-one for slides after our spotlight, so
  // the swiper jumps back to the previous image. We watch the swiper's
  // transform for unexpected changes within a short window after a click
  // and force-correct using the bullet primitive.
  function installLightboxGuard(wrapper) {
    if (wrapper.hasAttribute("data-spotlight-lb-guard")) return;
    wrapper.setAttribute("data-spotlight-lb-guard", "1");

    let pendingRestoreIdx = -1;
    let watchUntil = 0;
    let transformObs = null;

    wrapper.addEventListener(
      "click",
      function (e) {
        const slide = e.target.closest(".pwzrswiper-slide");
        if (!slide || slide.id === SLIDE_ID) return;
        const siblings = Array.from(
          wrapper.querySelectorAll(":scope > .pwzrswiper-slide"),
        );
        pendingRestoreIdx = siblings.indexOf(slide);
        watchUntil = Date.now() + 5000;
        console.log(LOG, "lb-guard: armed for slide DOM index", pendingRestoreIdx);

        if (!transformObs) {
          transformObs = new MutationObserver(() => {
            if (pendingRestoreIdx < 0 || Date.now() > watchUntil) {
              pendingRestoreIdx = -1;
              return;
            }
            const { activeIdx } = getActiveDomIndex(wrapper);
            if (activeIdx >= 0 && activeIdx !== pendingRestoreIdx) {
              const target = pendingRestoreIdx;
              pendingRestoreIdx = -1; // disarm before navigating
              console.log(
                LOG,
                "lb-guard: drift detected, active=",
                activeIdx,
                "expected=",
                target,
                "— restoring",
              );
              requestAnimationFrame(() => navigateToDomIndex(wrapper, target));
            }
          });
          transformObs.observe(wrapper, {
            attributes: true,
            attributeFilter: ["style"],
          });
        }
      },
      true,
    );
  }

  // ── 6. Thumbnail navigation ────────────────────────────────────────────────
  function navigateToSpotlight() {
    const wrapper = document.getElementById("pwzrswiper-wrapper");
    if (!wrapper) return;
    const allSlides = Array.from(
      wrapper.querySelectorAll(":scope > .pwzrswiper-slide"),
    );
    const spotlightSlide = document.getElementById(SLIDE_ID);
    const idx = allSlides.indexOf(spotlightSlide);
    if (idx === -1) return;
    navigateToDomIndex(wrapper, idx);
  }

  // ── 7. Injection ──────────────────────────────────────────────────────────
  function inject() {
    const wrapper = document.getElementById("pwzrswiper-wrapper");
    if (!wrapper) {
      console.log(LOG, "inject(): #pwzrswiper-wrapper not in DOM yet");
      return false;
    }
    if (wrapper.hasAttribute(INJECTED_ATTR)) {
      console.log(LOG, "inject(): already injected, skipping");
      return true;
    }

    const slides = Array.from(wrapper.querySelectorAll(".pwzrswiper-slide"));
    console.log(LOG, "inject(): found", slides.length, "slides");
    if (slides.length < 2) {
      console.log(LOG, "inject(): not enough slides yet, waiting...");
      return false;
    }

    // Already injected a spotlight slide?
    if (wrapper.querySelector("#" + SLIDE_ID)) {
      console.log(LOG, "inject(): spotlight slide already exists in DOM");
      wrapper.setAttribute(INJECTED_ATTR, "1");
      return true;
    }

    const firstSlide = slides.find((s) => s.getAttribute("data-index") === "0");
    const slideWidth = firstSlide
      ? parseInt(firstSlide.style.width) || 593
      : 593;
    console.log(LOG, "inject(): slideWidth =", slideWidth);

    // Don't shift sibling indices/IDs. The Rio app maps data-index → its
    // internal media[] array, and renaming siblings causes (a) the lightbox
    // to open the wrong image on click, and (b) the app's arrow handler to
    // skip slides (including the video). Insert spotlight before original
    // slide-2 in DOM order — Swiper uses DOM order for visual position,
    // and the app's media indices stay aligned.
    const insertBefore = wrapper.querySelector('[data-index="2"]');
    console.log(LOG, "inject(): insertBefore element:", insertBefore);

    const spotlight = buildSlide(slideWidth);
    wrapper.insertBefore(spotlight, insertBefore || null);
    wrapper.setAttribute(INJECTED_ATTR, "1");
    console.log(LOG, "inject(): spotlight slide inserted at position 3 ✓");

    // Re-sync Swiper to the mutated DOM (fixes wrong-image swipe + arrow drift).
    syncSwiper(wrapper);

    watchActiveClass(spotlight);
    watchForThumb();
    watchForArrows(wrapper);
    watchForThumbPatch(wrapper);
    installLightboxGuard(wrapper);

    // Watch for (a) the gallery re-rendering and dropping our slide, and
    // (b) the app appending new slides after init — e.g. the product video
    // slide gets added late by Rio, so Swiper's slide count stays stale and
    // arrows wrap from the last image back to slide 1 instead of advancing
    // to the video.
    let lastSlideCount = wrapper.querySelectorAll(":scope > .pwzrswiper-slide").length;
    let syncDebounce = null;
    new MutationObserver(() => {
      if (!document.getElementById(SLIDE_ID)) {
        console.log(
          LOG,
          "Spotlight slide removed by gallery re-render – re-injecting",
        );
        wrapper.removeAttribute(INJECTED_ATTR);
        inject();
        lastSlideCount = wrapper.querySelectorAll(":scope > .pwzrswiper-slide").length;
        return;
      }
      const count = wrapper.querySelectorAll(":scope > .pwzrswiper-slide").length;
      if (count !== lastSlideCount) {
        console.log(LOG, "Slide count changed", lastSlideCount, "→", count, "– re-syncing Swiper");
        lastSlideCount = count;
        clearTimeout(syncDebounce);
        syncDebounce = setTimeout(() => syncSwiper(wrapper), 50);
      }
    }).observe(wrapper, { childList: true });

    return true;
  }

  function tryInjectThumb() {
    const gallery = document.querySelector(".rio-media-gallery");
    if (!gallery) return false;

    let thumbGrid = null;
    const candidates = Array.from(
      gallery.querySelectorAll(".PwzrGrid-container"),
    );
    console.log(
      LOG,
      "tryInjectThumb(): total PwzrGrid-container elements:",
      candidates.length,
    );
    for (const g of candidates) {
      const items = g.querySelectorAll(":scope > .PwzrGrid-item");
      console.log(
        LOG,
        "tryInjectThumb(): candidate has",
        items.length,
        "direct PwzrGrid-item children, classes:",
        g.className,
      );
      if (items.length >= 2) {
        thumbGrid = g;
        break;
      }
    }

    if (!thumbGrid) {
      console.warn(LOG, "tryInjectThumb(): thumb grid not found yet");
      return false;
    }
    if (thumbGrid.hasAttribute(INJECTED_ATTR)) {
      console.log(LOG, "tryInjectThumb(): already injected");
      return true;
    }

    const thumbItems = thumbGrid.querySelectorAll(":scope > .PwzrGrid-item");
    // Insert before index 2 (position 3) to match the main slide position
    const insertBefore = thumbItems[2] || null;
    const thumb = buildThumb();

    // Make thumbnail clickable — navigate swiper to the spotlight slide
    const btn = thumb.querySelector('[role="button"]');
    if (btn) {
      btn.addEventListener("click", navigateToSpotlight);
      btn.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          navigateToSpotlight();
        }
      });
    }

    thumbGrid.insertBefore(thumb, insertBefore);
    thumbGrid.setAttribute(INJECTED_ATTR, "1");
    console.log(LOG, "tryInjectThumb(): thumbnail inserted at position 3 ✓");
    return true;
  }

  function watchForThumb() {
    if (tryInjectThumb()) return;
    const observer = new MutationObserver(() => {
      if (tryInjectThumb()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => {
      observer.disconnect();
      console.warn(LOG, "watchForThumb(): timed out");
    }, 15000);
  }

  // ── 8. Boot ───────────────────────────────────────────────────────────────
  function start() {
    console.log(LOG, "start() called, readyState:", document.readyState);
    if (inject()) return;

    let attempts = 0;
    const observer = new MutationObserver(() => {
      attempts++;
      if (inject()) {
        console.log(
          LOG,
          "Injected after",
          attempts,
          "MutationObserver callbacks",
        );
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => {
      observer.disconnect();
      console.warn(
        LOG,
        "MutationObserver timed out after 15s – gallery never found",
      );
    }, 15000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
